<template>
  <button
    class="btn"
    @click="$emit('click')"
  >
    <font-awesome-icon icon="arrow-left" class="mr-2" />{{ $t("actions.zurueck") }}
  </button>
</template>

<script>
  export default {};
</script>

<style>
</style>
